import { useAuthUrl } from 'features/auth/hooks/useAuthUrl/useAuthUrl';
import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { FeatureFlagKey } from 'services/statsig/types';
import { Headers } from 'shared/constants/headers';
import { ClientError } from 'shared/utils/errors';

export interface LoginPostData {
  emailAddress: string;
  password: string;
  aToken?: string;
  phoneNumber?: string;
}

export interface LoginResponse {
  idToken: string;
  refreshToken: string;
  version: string;
  challenge: string;
  phoneLineNumber?: string;
  session?: string;
  statusCode?: string;
  title?: string | undefined;
  message?: string | undefined;
  errorCode?: string;
  challengeId?: string;
  identityId?: string;
}

const postLoginRequest = async (
  lambdaUrl: string,
  data: LoginPostData,
  headers: Headers,
): Promise<LoginResponse> => {
  try {
    const response = await unauthenticatedFetch(`${lambdaUrl}/login`, {
      method: 'POST',
      cache: 'no-cache',
      body: JSON.stringify({
        phoneNumber: '',
        ...data,
      }),
      headers,
    });
    const responseJson = (await response.json()) as LoginResponse;
    return {
      ...responseJson,
      statusCode: response?.status?.toString(),
    };
  } catch (error) {
    if (error instanceof ClientError) {
      const body = error.responseBody as LoginResponse | undefined;
      return {
        ...body,
        statusCode: error.statusCode.toString(),
      } as LoginResponse;
    }
    throw error;
  }
};

function usePostLogin() {
  const authUrl = useAuthUrl(FeatureFlagKey.LOGIN_USE_K8S_AUTH_SERVICE);

  const postLogin = async (data: LoginPostData, headers: Headers) => {
    return await postLoginRequest(authUrl, data, headers);
  };
  return { postLogin };
}

export default usePostLogin;
